import React from 'react';

export function HpbBatteryIcon({ className }: { className?: string }) {
  return (
    <svg viewBox="0 0 64 64" fill="none" className={className} xmlns="http://www.w3.org/2000/svg">
      <rect x="12" y="16" width="40" height="32" rx="4" stroke="currentColor" strokeWidth="2" />
      <rect x="52" y="26" width="4" height="12" rx="1" fill="currentColor" />
      <rect x="17" y="21" width="8" height="22" rx="2" fill="currentColor" fillOpacity="0.9" />
      <rect x="28" y="21" width="8" height="22" rx="2" fill="currentColor" fillOpacity="0.7" />
      <rect x="39" y="21" width="8" height="22" rx="2" fill="currentColor" fillOpacity="0.5" />
      <path d="M30 8L26 16H32L28 24L34 14H28L30 8Z" fill="currentColor" fillOpacity="0.8" />
      <path d="M32 52L28 56H36L32 52Z" fill="currentColor" />
      <path d="M32 56V60" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
    </svg>
  );
}

export function KersIcon({ className }: { className?: string }) {
  return (
    <svg viewBox="0 0 64 64" fill="none" className={className} xmlns="http://www.w3.org/2000/svg">
      <circle cx="32" cy="32" r="28" stroke="currentColor" strokeWidth="2" strokeDasharray="8 4" />
      <circle cx="32" cy="32" r="20" stroke="currentColor" strokeWidth="2" />
      <path d="M35 18L25 34H31L29 46L39 30H33L35 18Z" fill="currentColor" />
      <path d="M48 32C48 40.8366 40.8366 48 32 48" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" />
      <path d="M32 52L28 48L32 44" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M16 32C16 23.1634 23.1634 16 32 16" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" />
      <path d="M32 12L36 16L32 20" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}

export function NfcUnlockIcon({ className }: { className?: string }) {
  return (
    <svg viewBox="0 0 64 64" fill="none" className={className} xmlns="http://www.w3.org/2000/svg">
      <rect x="8" y="20" width="32" height="24" rx="3" stroke="currentColor" strokeWidth="2" />
      <path d="M22 28C24.2091 28 26 29.7909 26 32C26 34.2091 24.2091 36 22 36" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
      <path d="M22 24C26.4183 24 30 27.5817 30 32C30 36.4183 26.4183 40 22 40" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
      <rect x="42" y="28" width="14" height="12" rx="2" stroke="currentColor" strokeWidth="2" />
      <path d="M45 28V24C45 21.2386 47.2386 19 50 19C52.7614 19 55 21.2386 55 24V28" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
      <circle cx="49" cy="34" r="2" fill="currentColor" />
    </svg>
  );
}

export function SmartAppIcon({ className }: { className?: string }) {
  return (
    <svg viewBox="0 0 64 64" fill="none" className={className} xmlns="http://www.w3.org/2000/svg">
      <rect x="18" y="8" width="28" height="48" rx="4" stroke="currentColor" strokeWidth="2" />
      <rect x="22" y="14" width="20" height="32" rx="1" stroke="currentColor" strokeWidth="1.5" />
      <rect x="25" y="18" width="6" height="6" rx="1" fill="currentColor" />
      <rect x="33" y="18" width="6" height="6" rx="1" fill="currentColor" fillOpacity="0.6" />
      <rect x="25" y="26" width="6" height="6" rx="1" fill="currentColor" fillOpacity="0.6" />
      <rect x="33" y="26" width="6" height="6" rx="1" fill="currentColor" />
      <rect x="29" y="50" width="6" height="2" rx="1" fill="currentColor" />
      <path d="M8 24C10.2091 24 12 25.7909 12 28" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
      <path d="M4 20C8.41828 20 12 23.5817 12 28" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
      <path d="M52 24C54.2091 24 56 25.7909 56 28" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
      <path d="M52 20C56.4183 20 60 23.5817 60 28" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
    </svg>
  );
}
